import { z } from "zod";

const organizationStructureSchema = z
  .object({
    area: z.object({ value: z.string(), label: z.string() }).nullable(),
    additionalArea: z
      .object({ value: z.string(), label: z.string() })
      .nullable(),
  })
  .passthrough()
  .refine(
    (data) =>
      !(
        data.area?.value &&
        data.additionalArea?.value &&
        data.area.value === data.additionalArea.value
      ),
    {
      message: "Obszar i dodatkowy obszar nie mogą być takie same.",
      path: ["additionalArea"],
    }
  );

export default organizationStructureSchema;
